export default __webpack_public_path__ + "static/media/icon-location.09853e6e.svg";